import React, { useState } from "react";
import { injectIntl } from "@edx/frontend-platform/i18n";
import { Image } from "@openedx/paragon";
import classNames from "classnames";
import { Form } from "@openedx/paragon";
import { getConfig } from "@edx/frontend-platform";

import messages from "../messages";
import { isAbsoluteUrl } from "../../../../utils";

import "react-tooltip/dist/react-tooltip.css";


const trimString = (string = "", length = 0) => {
  return string.length > length ? string.substring(0, length) + "..." : string;
};

function CardItem({
  elective,
  handleOpenModal,
  handleUpdateElective,
  selectedElectives,
  intl
}) {
  const isInProgress = elective.isSelected;
  const hasUnSelectElective =
    isInProgress && selectedElectives?.[elective.subsection] === undefined;
  const isChecked =
    hasUnSelectElective || !!selectedElectives?.[elective.subsection];

  const electiveStatus = elective.isComplete
    ? intl.formatMessage(messages.electiveDialogCompleted)
    : isInProgress
    ? intl.formatMessage(messages.electiveDialogInProgress)
    : null;

  const [isCardHover, setIsCardHover] = useState(false);
  const handleMouseEnter = (event) => {
    const element = event.target;
    const windowWidth = window.innerWidth;
    const rect = element.getBoundingClientRect();
    const positionLeft = rect.left > windowWidth/2;
    setIsCardHover(positionLeft);
  }

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleOpenModal(elective);
    }
  }

  return (
    <>
    <div tabindex="0" key={elective.subsection} role='button'
      onClick={() => handleOpenModal(elective)}
      onKeyPress={(event) => handleKeyPress(event)}
      onFocus={(event) => handleMouseEnter(event)}
      onMouseEnter={(event) => handleMouseEnter(event)}
      onMouseLeave={() => setIsCardHover(false)}
      className={classNames("card ", {
        "card--completed": elective.isComplete,
        "card--in-progress": isInProgress,
        "card--selected": !!selectedElectives?.[elective.subsection]
      })}>
      <div className="checkbox-input">
        <Form.Checkbox
          checked={isChecked}
          onClick={(event) => event.stopPropagation()}
          onChange={(event) => handleUpdateElective(event, elective)}
          name={elective.subsection}
          disabled={elective.isComplete}
        />
      </div>
      <div className="card-image">
        <Image src={isAbsoluteUrl(elective.icon) ? elective.icon : `${getConfig().LMS_BASE_URL}${elective.icon}`} alt="icon" />
      </div>
      <div
        className="card-content"
        id={elective.subsection}
      >
        {trimString(elective.displayName, 50)}
      </div>

      {electiveStatus ? (
        <div className="card-chip">
          <div
            className={classNames("card-action", {
              "in-progress": isInProgress,
              "completed": elective.isComplete,
            })}
          >
            {electiveStatus}
          </div>
        </div>
      ): null}
    </div>
    </>
  );
}

export default injectIntl(CardItem);
